var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('custom-popover', { attrs: { "label": _vm.label, "model": _vm.model, "popover-config": _vm.popoverConfig, "selectedValue": _vm.selectedValue, "popoverSchema": _vm.popoverSchema }, on: { "change": _vm.handleChange, "remove-tag": _vm.deleteTag, "clear": _vm.handleClearClick } });
};
var staticRenderFns = [];

export { render, staticRenderFns };